module.exports = __webpack_public_path__ + "static/media/SF-9-A.0de4fd7a.mp3";